import type { LeadListSource } from "./types";

// Sources without a completed mining run yet may not have last_mined_at set.
export function getLeadListLastMinedAt(
  sources: LeadListSource[],
): string | undefined {
  return sources.reduce<string | undefined>((latest, source) => {
    if (!source.last_mined_at) return latest;
    if (!latest || new Date(source.last_mined_at) > new Date(latest)) {
      return source.last_mined_at;
    }
    return latest;
  }, undefined);
}

// Detects clicks on an actions trigger or its portaled menu/dialog content
// (dropdown menu, drawer, confirmation dialog). These are logically nested
// inside a clickable row/link, but their content renders in a portal, so
// this lets the row/link ignore such clicks instead of every trigger and
// portaled element having to stop the click from propagating.
export function isActionsElementClick(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement &&
    !!target.closest(
      '[aria-haspopup], [role="menu"], [role="menuitem"], [role="dialog"]',
    )
  );
}
